import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function DataProtections() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sections = [
    {
      number: "2",
      title: t("dataProtections.s2.title"),
      content: (
        <>
          <p>{t("dataProtections.s2.p1")}</p>
          <ul>
            <li>{t("dataProtections.s2.l1")}</li>
            <li>{t("dataProtections.s2.l2")}</li>
            <li>{t("dataProtections.s2.l3")}</li>
            <li>{t("dataProtections.s2.l4")}</li>
            <li>{t("dataProtections.s2.l5")}</li>
            <li>{t("dataProtections.s2.l6")}</li>
            <li>{t("dataProtections.s2.l7")}</li>
            <li>{t("dataProtections.s2.l8")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "3",
      title: t("dataProtections.s3.title"),
      content: (
        <>
          <p>{t("dataProtections.s3.p1")}</p>
          <ul>
            <li>{t("dataProtections.s3.l1")}</li>
            <li>{t("dataProtections.s3.l2")}</li>
            <li>{t("dataProtections.s3.l3")}</li>
            <li>{t("dataProtections.s3.l4")}</li>
            <li>{t("dataProtections.s3.l5")}</li>
            <li>{t("dataProtections.s3.l6")}</li>
            <li>{t("dataProtections.s3.l7")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "4",
      title: t("dataProtections.s4.title"),
      content: (
        <>
          <p>{t("dataProtections.s4.p1")}</p>
          <p>{t("dataProtections.s4.p2")}</p>
        </>
      ),
    },
    {
      number: "5",
      title: t("dataProtections.s5.title"),
      content: (
        <>
          <p>{t("dataProtections.s5.p1")}</p>
          <p>{t("dataProtections.s5.p2")}</p>
        </>
      ),
    },
    {
      number: "6",
      title: t("dataProtections.s6.title"),
      content: (
        <>
          <p>{t("dataProtections.s6.p1")}</p>
          <p>{t("dataProtections.s6.p2")}</p>
        </>
      ),
    },
    {
      number: "7",
      title: t("dataProtections.s7.title"),
      content: <p>{t("dataProtections.s7.p1")}</p>,
    },
    {
      number: "8",
      title: t("dataProtections.s8.title"),
      content: (
        <>
          <p>{t("dataProtections.s8.p1")}</p>
          <p>{t("dataProtections.s8.p2")}</p>
        </>
      ),
    },
    {
      number: "9",
      title: t("dataProtections.s9.title"),
      content: (
        <>
          <p>{t("dataProtections.s9.p1")}</p>
          <ul>
            <li>{t("dataProtections.s9.l1")}</li>
            <li>{t("dataProtections.s9.l2")}</li>
            <li>{t("dataProtections.s9.l3")}</li>
            <li>{t("dataProtections.s9.l4")}</li>
            <li>{t("dataProtections.s9.l5")}</li>
            <li>{t("dataProtections.s9.l6")}</li>
          </ul>
          <p>{t("dataProtections.s9.p2")} <a href="mailto:info@transcirox.com">info@transcirox.com</a></p>
        </>
      ),
    },
    {
      number: "10",
      title: t("dataProtections.s10.title"),
      content: (
        <>
          <p>{t("dataProtections.s10.p1")}</p>
        </>
      ),
    },
  ];

  return (
    <>
      <SEO
        title="TransCirox – Datenschutzerklärung | Datenschutz"
        description="Datenschutzerklärung der TransCiroX GmbH. Informationen zum Schutz Ihrer personenbezogenen Daten bei der Nutzung der TransCiroX-App."
        keywords="Datenschutz, Datenschutzerklärung, DSGVO, personenbezogene Daten, TransCiroX"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("dataProtections.title")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>
                  {t("dataProtections.mainTitle")}
                  <br />
                  {t("dataProtections.subtitle")}
                </h1>

                <p>{t("dataProtections.intro")}</p>

                <h3>{t("dataProtections.responsible")}</h3>
                <p>
                  {t("dataProtections.company")}<br />
                  {t("dataProtections.address")}<br />
                  {t("dataProtections.country")}
                </p>
                <p>{t("dataProtections.email")}: <a href="mailto:info@transcirox.com">info@transcirox.com</a></p>

                <hr />

                {sections.map((section) => (
                  <div key={section.number} className="document-section">
                    <h3>
                      {section.number}. {section.title}
                    </h3>
                    <div>{section.content}</div>
                    <hr />
                  </div>
                ))}

                {/* Footer */}
                <div className="document-meta">
                  <p>{t("dataProtections.footer")}</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}